module.exports = ".stadium-img {\n  width: auto;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n  height: 100%;\n  top: 0;\n}\n\n.stadium-img {\n  width: 100%;\n}\n\n@media screen and (max-width: 600px) {\n  .stadium-img {\n    width: 90%;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/group/components/choose-seats/seat-map/seat-map.component.css
// module id = ./src/app/modules/group/components/choose-seats/seat-map/seat-map.component.css
// module chunks = main